export default {
  drawerWidth: 238,
};
